import { useFlyOutProductsBasedOnSelectedCloud } from '../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import React, { useEffect } from 'react'

import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { PlanType } from '@labrav/react-components'
import { getCurrentResaleAuthorization } from '../../../admin/modules/resaleAuthorizations'

import { useDispatch, useSelector } from '../../../store'
import { useStyles } from './ViewResaleAuthorizationWrapper.styles'
import { ViewResaleAuthorization } from './ViewResaleAuthorization/ViewResaleAuthorization'
import type { ViewResaleAuthorizationWrapperProps } from '../types'
import type { RootState } from '../../../store/types'

export { getActiveStepLable } from '../helpers'
export type { ViewResaleAuthorizationWrapperProps }

export const ViewResaleAuthorizationWrapper: React.FC<
  ViewResaleAuthorizationWrapperProps
> = ({ crmOpportunityId, externalBaseURL }) => {
  const dispatch = useDispatch()
  const { classes } = useStyles()
  const partnerId = useSelector(
    (state: RootState) => state.AccountData.user.partnerData?.partnerId || ''
  )
  const { resaleAuthorizationId: resaleAuthorizationIdParam } = useParams<{
    productId: string
    resaleAuthorizationId: string
  }>()
  const resaleAuthorizationId = resaleAuthorizationIdParam as string

  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const { resaleAuthorization, productType } = useSelector(
    (state: RootState) => {
      const resaleAuthorization =
        state.cppoReseller.currentResaleAuthorization[resaleAuthorizationId]
      const productType =
        products.find(
          product =>
            product.productId ===
              resaleAuthorization?.products[0].awsProductId ||
            product.productId === resaleAuthorization?.awsProductId
        )?.productType || PlanType.SAAS_CONTRACT
      return {
        resaleAuthorization,
        productType,
      }
    }
  )

  useEffect(() => {
    if (!crmOpportunityId && !externalBaseURL && !isEmpty(partnerId)) {
      {
        dispatch(
          getCurrentResaleAuthorization({
            cloud: 'AWS',
            partnerId,
            resaleAuthorizationId,
            crmOpportunityId,
          })
        )
      }
    }
  }, [partnerId, resaleAuthorizationId, crmOpportunityId, externalBaseURL])

  return isEmpty(resaleAuthorization) ? (
    <div data-testid="empty-private-offer-wrapper"></div>
  ) : (
    <>
      <div className={classes.stepperWrapper} data-testid="stepperDiv">
        <ViewResaleAuthorization
          resaleAuthorization={resaleAuthorization}
          planType={productType}
        />
      </div>
    </>
  )
}
